import * as React from "react";

/*  PageBrowser helps to separate numerous enlisted elements into groups and browse through these groups with
    numerical and forward/backward buttons. The PageBrowser instance should be kept where it will last longer or as long as the 
    page it controls and refreshes, but its render method will generate a temporary react component which may be part of
    that same page which is regenerated whenever the PageBrowser is being used. */

export class PageBrowser {
    initiate(resultGroupLength: number, resultGroupRange: number, hitsString: string, noHitsString: string) {
        this.m_hitsString = hitsString
        this.m_noHitsString = noHitsString
        this.m_resultGroupLength = resultGroupLength
        this.m_resultGroupRange = resultGroupRange
        this.m_resultGroup = 0
        this.m_resultGroupStart = 0
    }

    connect(onUpdatePage: () => void, getTotalElements: () => number) {
        this.mf_onUpdatePage = onUpdatePage
        this.mf_getTotalElements = getTotalElements
        this.m_totalElements = this.mf_getTotalElements()
    }
    
    render(isFooter: boolean) {

        if (isFooter == true) {
            return <PageBrowserControl pageBrowser={this} initialTotalElements={this.m_totalElements} initialResultGroupLength={this.m_resultGroupLength} initialResultGroupRange={this.m_resultGroupRange} hitsString={this.m_hitsString} noHitsString={""} onUpdatePage={this.mf_onUpdatePage.bind(this)} getTotalElements={this.mf_getTotalElements.bind(this)} />
        }
        else {
            return <PageBrowserControl pageBrowser={this} initialTotalElements={this.m_totalElements} initialResultGroupLength={this.m_resultGroupLength} initialResultGroupRange={this.m_resultGroupRange} hitsString={this.m_hitsString} noHitsString={this.m_noHitsString} onUpdatePage={this.mf_onUpdatePage.bind(this)} getTotalElements={this.mf_getTotalElements.bind(this)} />
        }
        
    }

    GetCurrentStartPosition() {
        return this.m_resultGroup * this.m_resultGroupLength
    }

    GetCurrentEndPosition() {
        if (((this.m_resultGroup * this.m_resultGroupLength) + this.m_resultGroupLength) > this.mf_getTotalElements()) {
            return this.mf_getTotalElements()
        }
        else {
            return (this.m_resultGroup * this.m_resultGroupLength) + this.m_resultGroupLength
        }
    }

    GetResultGroup() {
        return this.m_resultGroup
    }

    GetStartGroup() {
        return this.m_resultGroupStart
    }

    SetPosition(resultGroup: number, resultGroupStart: number) {
        this.m_resultGroup = resultGroup
        this.m_resultGroupStart = resultGroupStart
        this.mf_onUpdatePage()
    }

    private mf_getTotalElements: () => number
    private m_totalElements: number

    private m_resultGroupLength: number
    private m_resultGroupRange: number
    private m_hitsString: string
    private m_noHitsString: string

    private m_resultGroup: number // The presently selected "page" of enlisted elements. For example resultGroup:2 means results between 50 (25*2) and 74 (25*2+(25-1)) with a group size of 25
    private m_resultGroupStart: number // This determines from what set of groups the sets will be displayed, for example if 10 and resultGroup is 12, buttons will go from 10 to 19 with 12 highlighted

    private mf_onUpdatePage: () => void
}

export interface PageBrowserVm {
    pageBrowser: PageBrowser,
    initialTotalElements: number,
    initialResultGroupLength: number,
    initialResultGroupRange: number,
    hitsString: string,
    noHitsString: string,
    onUpdatePage: () => void,
    getTotalElements: () => number
}

export interface PageBrowserState {
    resultTotalElements: number,
    resultGroupLength: number, // The amount of elements that can be shown at once within a page, the total amount is divided into groups by this size
    resultGroupRange: number, // This tells how many groups should be displayed at once when there are many, default is 10
}

class PageBrowserControl extends React.Component<PageBrowserVm, PageBrowserState> {
    constructor(props: PageBrowserVm) {
        super(props)
    }

    state: PageBrowserState = {
        resultTotalElements: this.props.initialTotalElements,
        resultGroupLength: this.props.initialResultGroupLength,
        resultGroupRange: this.props.initialResultGroupRange
    }

    // Sets the core's reference back to this view on initiation
    componentWillMount() {
    }

    // Passes on clicks to a handler within Core:
    onClick() {
    }

    render() {
        var totalSource = this.state.resultTotalElements

        const hits = " " + this.props.hitsString
        const noHits = this.props.noHitsString
        
        const total = totalSource
        const step = this.state.resultGroupLength
        const lastSize = total % step
        const groups = ((total - lastSize) / step) + ((lastSize != 0) ? 1 : 0)
        const range = this.state.resultGroupRange

        var testInfo = "Viser " + ((this.props.pageBrowser.GetResultGroup() * step) + 1).toString() + "-" + ((((this.props.pageBrowser.GetResultGroup() + 1) * step) < total) ? ((this.props.pageBrowser.GetResultGroup() + 1) * step) : total).toString() + " av " + total.toString() + hits
        if (total == 0) {
            testInfo = noHits
        }

        if (groups < 2) {
            if (noHits == "") {
                return <div></div>
            }
            else {
                return <div>{testInfo}</div>
            }
        }
        else {
            if (groups < range) {
                return <div>
                    {testInfo}
                    <div style={{ display: "flex", direction: "row" }}>
                        {this.RenderDisplaySectionNumericalButton(0)}
                        {this.RenderDisplaySectionNumericalButton(1)}
                        {this.RenderDisplaySectionNumericalButton(2)}
                        {this.RenderDisplaySectionNumericalButton(3)}
                        {this.RenderDisplaySectionNumericalButton(4)}
                        {this.RenderDisplaySectionNumericalButton(5)}
                        {this.RenderDisplaySectionNumericalButton(6)}
                        {this.RenderDisplaySectionNumericalButton(7)}
                        {this.RenderDisplaySectionNumericalButton(8)}
                        {this.RenderDisplaySectionNumericalButton(9)}
                    </div>
                </div>
            }
            else {
                return <div>
                    {testInfo}
                    <div style={{ display: "flex", direction: "row" }}>
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Til begynnelsen" Width="34" Height="29" pageBrowserControl={this} buttonID="allBack" buttonBaseOffset={0} buttonText="" position={-1} active={this.props.pageBrowser.GetResultGroup() != 0} />
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Tilbake ti skritt" Width="32" Height="29" pageBrowserControl={this} buttonID="rewind" buttonBaseOffset={34} buttonText="" position={-1} active={this.props.pageBrowser.GetResultGroup() != 0} />
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Tilbake et skritt" Width="31" Height="29" pageBrowserControl={this} buttonID="backward" buttonBaseOffset={66} buttonText="" position={-1} active={this.props.pageBrowser.GetResultGroup() != 0} />
                        {this.RenderDisplaySectionNumericalButton(0)}
                        {this.RenderDisplaySectionNumericalButton(1)}
                        {this.RenderDisplaySectionNumericalButton(2)}
                        {this.RenderDisplaySectionNumericalButton(3)}
                        {this.RenderDisplaySectionNumericalButton(4)}
                        {this.RenderDisplaySectionNumericalButton(5)}
                        {this.RenderDisplaySectionNumericalButton(6)}
                        {this.RenderDisplaySectionNumericalButton(7)}
                        {this.RenderDisplaySectionNumericalButton(8)}
                        {this.RenderDisplaySectionNumericalButton(9)}
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Fremover et skritt" Width="31" Height="29" pageBrowserControl={this} buttonID="forward" buttonBaseOffset={97} buttonText="" position={-1} active={(this.props.pageBrowser.GetResultGroup() + 1) < groups} />
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Fremover ti skritt" Width="31" Height="29" pageBrowserControl={this} buttonID="fastForward" buttonBaseOffset={128} buttonText="" position={-1} active={(this.props.pageBrowser.GetResultGroup() + 1) < groups} />
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Til sluttet" Width="33" Height="29" pageBrowserControl={this} buttonID="toEnd" buttonBaseOffset={159} buttonText="" position={-1} active={(this.props.pageBrowser.GetResultGroup() + 1) < groups} />
                    </div>
                </div>
            }
        }
    }
    
    // Renders a single numerical search result orientation button
    RenderDisplaySectionNumericalButton(increment: number) {
        const total = this.state.resultTotalElements
        const step = this.state.resultGroupLength
        const lastSize = total % step
        const groups = ((total - lastSize) / step) + ((lastSize != 0) ? 1 : 0)
        const range = this.state.resultGroupRange
        const thisPos = this.props.pageBrowser.GetStartGroup() + increment

        var isSelected = (thisPos == this.props.pageBrowser.GetResultGroup()) ? true : false
        var graphicsOffset = isSelected ? 228 : 195

        var tooltip = "resultater fra " + ((thisPos * step) + 1).toString() + " til " + ((thisPos + 1) * step).toString()
        var buttonText = thisPos.toString()

        // Out of range - returning an empty div instead
        if (thisPos >= groups) {
            return <div></div>
        }

        return <OrientationButton FilenameBase="selectionSplitButtons" TooltipText={tooltip} Width="31" Height="29" pageBrowserControl={this} buttonID="numerical" buttonBaseOffset={graphicsOffset} buttonText={buttonText} position={thisPos} active={true} />
    }

    ClearFocus() {
        if (this.props.onUpdatePage != null) {
            this.props.onUpdatePage()
        }
    }
    
    // Handlers for all the orientation button clicks
    HandleOriButton(buttonID: string, position: number) {
        const total = this.state.resultTotalElements
        const step = this.state.resultGroupLength
        const lastSize = total % step
        const groups = ((total - lastSize) / step) + ((lastSize != 0) ? 1 : 0)
        const range = this.state.resultGroupRange

        // Moves the viewed group all the way to the start (0)
        if (buttonID == "allBack") {
            this.props.pageBrowser.SetPosition(0,0)
        }

        // Moves the viewed group 10 steps backward
        if (buttonID == "rewind") {
            var newPos = this.props.pageBrowser.GetResultGroup() - range
            if (newPos < 0) {
                newPos = 0
            }

            var newStart = newPos - (range / 2)

            if (newStart < 0) {
                newStart = 0
            }

            this.props.pageBrowser.SetPosition(newPos, newStart)
        }

        // Moves the viewed group 1 step backward
        if (buttonID == "backward") {
            var newPos = this.props.pageBrowser.GetResultGroup() - 1
            if (newPos < 0) {
                newPos = 0
            }

            var newStart = this.props.pageBrowser.GetStartGroup()
            if (newStart > newPos) {
                newStart -= range
                if (newStart < 0) {
                    newStart = 0
                }
            }

            this.props.pageBrowser.SetPosition(newPos,newStart)
        }

        // Moves the viewed group 1 step forward
        if (buttonID == "forward") {
            var newPos = this.props.pageBrowser.GetResultGroup() + 1
            var newStart = this.props.pageBrowser.GetStartGroup()

            if ((newStart + range) <= newPos) {
                newStart += range
            }

            if (newPos >= groups) {
                newPos = groups - 1
                newStart = groups - range
            }

            if (newStart < 0) {
                newStart = 0
            }

            this.props.pageBrowser.SetPosition(newPos, newStart)
        }

        // Moves the viewed group 10 steps forward
        if (buttonID == "fastForward") {
            var newPos = this.props.pageBrowser.GetResultGroup() + range

            if (newPos >= groups) {
                newPos = groups - 1
            }

            var newStart = newPos - (range / 2)

            if (newStart < 0) {
                newStart = 0
            }

            this.props.pageBrowser.SetPosition(newPos, newStart)
        }

        // Moves the viewed group all the way to the last one
        if (buttonID == "toEnd") {
            var newPos = groups - 1
            if (newPos < 0) {
                newPos = 0
            }

            var newStart = newPos - (range - 1)

            if (newStart < 0) {
                newStart = 0
            }

            this.props.pageBrowser.SetPosition(newPos, newStart)
        }

        // Numerical buttons
        if (buttonID == "numerical") {
            this.props.pageBrowser.SetPosition(position, this.props.pageBrowser.GetStartGroup())
        }
    }
}

interface OrientationButtonVm {
    FilenameBase: string
    TooltipText: string
    Width: string
    Height: string
    pageBrowserControl: PageBrowserControl
    buttonID: string
    buttonBaseOffset: number
    position: number
    buttonText: string
    active: boolean
}

export interface OrientationButtonSm {
    buttonStageOffset: number
}

// OrientationButton is a buttonlike control for orientation among large number of results, divided
// into groups of a certain maximum amount, for optimization reasons. This control will let you
// browse the results, click on a certain numbered section of results and the selected section will
// be highlighted in dark blue.
// Clicks on these buttons are passed on to an external handler, after affecting the page browser.
class OrientationButton extends React.Component<OrientationButtonVm, OrientationButtonSm> {
    constructor(props: OrientationButtonVm) {
        super(props)
    }

    state = {
        buttonStageOffset: 0
    }

    // The final handler is located in BDKalkCore
    onClick() {
        if (this.props.active == true) {
            this.props.pageBrowserControl.HandleOriButton(this.props.buttonID, this.props.position)
        }
    }

    // This handler will affect the graphics only
    onMouseDown() {
        if (this.props.active == true) {
            this.setState({ buttonStageOffset: 639 })
        }
    }

    // This handler will affect the graphics only
    onMouseUp() {
        if (this.props.active == true) {
            this.setState({ buttonStageOffset: 0 })
        }
    }

    // This handler will affect the graphics only
    onMouseOut() {
        if (this.props.active == true) {
            this.setState({ buttonStageOffset: 0 })
        }
    }

    // Renders the orientation button
    render() {
        const baseName = this.props.FilenameBase;
        const numString = this.props.position.toString()
        const leftAlign = ((14 - (numString.length * 4)).toString() + "px")

        // Numerical buttons:
        if (this.props.buttonID == "numerical") {
            if (this.props.position == this.props.pageBrowserControl.props.pageBrowser.GetResultGroup()) {
                return <div className="tooltip" style={{ marginLeft: "0px" }}>
                    <div style={{
                        backgroundImage: "url(images/selectionSplitButtons.png)",
                        backgroundPosition: "-" + (this.props.buttonBaseOffset + 324).toString() + "px -0px",
                        width: this.props.Width.toString() + "px",
                        height: this.props.Height.toString() + "px"
                    }}>
                    </div>
                    <div style={{
                        color: "white",
                        width: (numString.length * 6).toString() + "px",
                        height: 16 + "px",
                        position: "relative",
                        top: "-23px",
                        left: leftAlign
                    }}>
                        {numString}
                    </div>
                    <span className="tooltiptext">{this.props.TooltipText}</span>
                </div >;
            }
            else {
                return <div className="tooltip" style={{ marginLeft: "0px" }}>
                    <div
                        onClick={this.onClick.bind(this)}
                        onMouseDown={this.onMouseDown.bind(this)}
                        onMouseUp={this.onMouseUp.bind(this)}
                        onMouseOut={this.onMouseOut.bind(this)}
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/selectionSplitButtons.png)",
                            backgroundPosition: "-" + (this.state.buttonStageOffset + this.props.buttonBaseOffset).toString() + "px -0px",
                            width: this.props.Width.toString() + "px",
                            height: this.props.Height.toString() + "px"
                        }}>
                    </div>
                    <div
                        onClick={this.onClick.bind(this)}
                        onMouseDown={this.onMouseDown.bind(this)}
                        onMouseUp={this.onMouseUp.bind(this)}
                        style={{
                            cursor: "pointer",
                            color: "black",
                            width: (numString.length * 6).toString() + "px",
                            height: 16 + "px",
                            position: "relative",
                            top: "-23px",
                            left: leftAlign
                        }}>
                        {numString}
                    </div>
                    <span className="tooltiptext">{this.props.TooltipText}</span>
                </div>
            }
        }

        // Non numerical buttons:
        if (this.props.active == true) {
            return <div className="tooltip" style={{ marginLeft: "0px" }}>
                <div
                    onClick={this.onClick.bind(this)}
                    onMouseDown={this.onMouseDown.bind(this)}
                    onMouseUp={this.onMouseUp.bind(this)}
                    onMouseOut={this.onMouseOut.bind(this)}
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/selectionSplitButtons.png)",
                        backgroundPosition: "-" + (this.state.buttonStageOffset + this.props.buttonBaseOffset).toString() + "px -0px",
                        width: this.props.Width.toString() + "px",
                        height: this.props.Height.toString() + "px"
                    }}>

                </div>
                <span className="tooltiptext">{this.props.TooltipText}</span>
            </div>
        }
        else {
            // This button is greyed out and can't be used, it's only cosmetical.
            return <div className="tooltip" style={{ marginLeft: "0px" }}>
                <div style={{
                    backgroundImage: "url(images/selectionSplitButtons.png)",
                    backgroundPosition: "-" + (this.props.buttonBaseOffset + 324).toString() + "px -0px",
                    width: this.props.Width.toString() + "px",
                    height: this.props.Height.toString() + "px"
                }}>

                </div >
                <span className="tooltiptext">{this.props.TooltipText}</span>
            </div >;
        }
    }
}



// WEBPACK FOOTER //
// ./client/view/PageBrowser.tsx